<template>
  <div id="patient-visit-services-summary"
       class="patient-visit-services-table-card">
    <h3 v-if="showTitle">{{ $t('services') }}</h3>
    <div v-if="services.length" class="patient-visit-services-table">
      <div class="row no-gutters font-weight-bold table-header">
        <div class="col-1 col-td">{{ $t('code') }}</div>
        <div class="col-2 col-td">{{ $t('service') }}</div>
        <div class="col-2 col-td">{{ $t('cost') }}</div>
        <div class="col-2 col-td">{{ $t('amount') }}</div>
        <div class="col-2 col-td">{{ $t('discount') }} ({{ currency }} / %)</div>
        <div class="col-2 col-td">{{ $t('total') }}</div>
        <div class="col-1 col-td"></div>
      </div>
      <PatientVisitServiceTableRow v-for="service in services"
                                   :service="service"
                                   :view="view"
                                   :readonly="readOnly || !editMode"
                                   :key="`service-${service.id}`"/>
    </div>
    <div v-else class="text-label-color small">{{ $t('services_not_selected') }}</div>
  </div>
</template>

<script setup>
import {computed, inject, ref, watch} from "vue"
import {useStore} from "vuex"
import PatientVisitServiceTableRow from "@/components/parts/patients/visit/teethTab/PatientVisitServiceTableRow.vue"

const store = useStore()

defineProps({
  view: {
    type: String,
    default: 'visit'
  },
  showTitle: {
    type: Boolean,
    default: true
  }
})

const cannotChange = inject('cannotChange')
const editMode = inject('editMode')

const rights = computed(() => store.state.auth.rights)
const visitHasPayments = computed(() => store.getters.visitHasPayments)
const currency = computed(() => store.getters.getCurrencyName)
const cannotChangeServices = computed(() => !rights.value.includes('add_edit_visit_services') || visitHasPayments.value)
const readOnly = computed(() => cannotChange.value || cannotChangeServices.value)

const rawServices = computed(() => store.getters.recordTeethServicesSorted)
// recordTeethServicesSorted orders services by which tooth's occurrence is walked first, which can
// change when a per-tooth quantity is edited to zero (the next tooth becomes the "first" occurrence)
// - track first-seen order locally so row order stays stable across quantity changes
const orderedIds = ref([])
watch(rawServices, (raw) => {
  const ids = raw.map(s => s.id)
  orderedIds.value = orderedIds.value.filter(id => ids.includes(id))
  for(const id of ids) {
    if(!orderedIds.value.includes(id)) orderedIds.value.push(id)
  }
}, { immediate: true })

const services = computed(() => {
  const byId = new Map(rawServices.value.map(s => [s.id, s]))
  return orderedIds.value.map(id => byId.get(id)).filter(Boolean)
})
</script>

<style scoped lang="scss">
.patient-visit-services-table-card-table {
  border-radius: 8px;
}
</style>
